import HourHero from 'assets/images/psp/hero/24-hour-hero.webp';
import twentyFourHourIcon from 'assets/images/psp/amenities/24-hour.svg';
import shopIcon from 'assets/images/icons/psp/shop.svg';
import movingIcon from 'assets/images/psp/amenities/moving.svg';
import timeIcon from 'assets/images/psp/amenities/time.svg';
import sparkIcon from 'assets/images/psp/amenities/9.svg';
import fiveByTenIcon from 'assets/images/unit-icons/new/5x10.svg';
import tenByTenIcon from 'assets/images/unit-icons/new/10x10.svg';
import tenByFifteenIcon from 'assets/images/unit-icons/new/10x15.svg';
import tenByTwentyIcon from 'assets/images/unit-icons/new/10x20.svg';
import tenByThirtyIcon from 'assets/images/unit-icons/new/10x30.svg';
import Featured1 from 'assets/images/psp/FeaturedImages/self3.webp';
import Featured2 from 'assets/images/psp/FeaturedImages/24HourFeatured2.webp';
import Featured3 from 'assets/images/psp/FeaturedImages/24HourFeatured3.webp';

const reviews = [
	{
		reviewTitle: 'SpareFoot helped me secure a storage unit and…',
		reviewRating: 5,
		reviewText:
			'SpareFoot helped me secure a storage unit and make a reservation with little personal information. I was able to see and compare many storage locations, storage type, price and size online before deciding.I was contacted right away by a real person who was very friendly and informative. The personal service is very important.',
		reviewerInitials: 'AL',
		reviewerName: 'Alice',
		reviewDate: 'January 3rd, 2023',
		link: 'https://www.trustpilot.com/reviews/68d78fcd296d476c63e494c0',
	},
	{
		reviewTitle: 'Made picking a storage facility quick and easy',
		reviewRating: 5,
		reviewText:
			'SpareFoot made it very easy to choose and reserve the storage facility that I wanted. Received quick notification from the storage facility about my reservation. Everything went smoothly.',
		reviewerInitials: 'DA',
		reviewerName: 'Dawn',
		reviewDate: 'January 3rd, 2023',
		link: 'https://www.trustpilot.com/reviews/68d373416f678003b1f8cfb9',
	},
	{
		reviewTitle: 'Quick and easy',
		reviewRating: 5,
		reviewText:
			'I was able to reserve what I needed online with SpareFoot, and the phone contact was well within 24 hours and very personable. Decent price compared to other storage places in the area. Convenient, quiet, and easy to get to. Highly recommend.',
		reviewerInitials: 'BA',
		reviewerName: 'Barbara',
		reviewDate: 'January 3rd, 2023',
		link: 'https://www.trustpilot.com/reviews/68d054bd80f72e95a81079be',
	},
	{
		reviewTitle: 'I have used SpareFoot in the past and…',
		reviewRating: 5,
		reviewText:
			'I have used Spare Foot in the past and was very pleased with their service. Recently, I had minutes to find a storage unit so I got in touch with them and they had me set up in the nick of time. Spare Foot will always be my go to for storage needs.',
		reviewerInitials: 'JO',
		reviewerName: 'John',
		reviewDate: 'January 3rd, 2023',
		link: 'https://www.trustpilot.com/reviews/68c2e914b6a28af5a755844a',
	},
];
const faqs = [
	{
		question: 'What does 24-hour access storage mean?',
		answer: "24-hour storage means you can access your storage unit anytime, day or night, using a personal access code or key card at the facility's security gate.",
	},
	{
		question: 'Are 24/7 storage units more expensive than regular storage?',
		answer: '24-hour storage typically costs the same as standard units, with units ranging from $35.27/month for a 5×5 up to $165.85/month for a 10×30.',
	},
	{
		question: 'Is 24-hour access storage safe?',
		answer: 'Yes, 24-hour storage facilities maintain security through surveillance cameras, electronic gate systems, individual unit locks, and well-lit properties to ensure safe access at all hours.',
	},
	{
		question: 'Can I get 24-hour access storage with electricity?',
		answer: 'Many facilities offer 24-hour access storage with electricity near me, perfect for charging vehicles, running equipment, or powering lights during late-night visits.',
	},
	{
		question: 'Do I need to notify the facility when I visit after hours?',
		answer: "No notification is required—that's the beauty of 24/7 storage. Simply use your access code to enter the facility whenever you need.",
	},
	{
		question:
			'What amenities should I look for in a 24 hr storage facility?',
		answer: 'Look for well-lit properties, drive-up access for convenient loading, surveillance systems, and clean, paved driveways for safe nighttime visits.',
	},
];
export const TwentyFourHourContent = {
	type: '24-Hour',
	sections: [
		{
			title: '24-Hour-Storage',
			background: 'yellow',
			modules: [
				{
					type: 'hero',
					id: '24-Hour-storage-hero',
					background: 'lighterYellow',
					props: {
						content: {
							title: 'Find the Best 24 Hour Storage For You',
							description:
								"Life doesn't run on a 9-to-5 schedule, so why should your storage? Whether you're a night owl who works best after midnight, a business owner restocking inventory at dawn, or someone whose moving day just became a moving night, 24-hour access storage gives you the freedom to access your belongings whenever you need them—no appointments, no waiting, no hassle. Take back control of your schedule with the help of SpareFoot.",
							image: HourHero,
							CTAText: 'Find 24 Hour Storage',
						},
					},
				},
			],
		},
		{
			title: 'nearby storage',
			noPaddingBottom: true,
			background: 'gray',
			modules: [
				{
					type: 'facilitiesNearYou',
					props: {
						title: 'Find 24 Hour Storage Near',
					},
				},
			],
		},
		{
			title: 'Why Choose 24-Hour Access Storage?',
			noPaddingBottom: true,
			modules: [
				{
					type: 'content',
					props: {
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: ['## Why Choose 24-Hour Access Storage?'],
					},
				},
				{
					type: 'unitList',
					props: {
						slug: '24-hour-amenities-section',
						headerLink: '#24-hour-amenities-section',
						scrollFactor: 0.8,
						unitsData: [
							{
								image: shopIcon,
								content:
									'#### For Business Owners & Entrepreneurs\n\n' +
									'Stock your retail space early, retrieve inventory for weekend markets, or access business documents outside\n\n',
								newlayout: false,
							},
							{
								image: movingIcon,
								content:
									'#### For Moving & Staging\n\n' +
									"Moving trucks don't always arrive during business hours. With 24-hour storage, you can load and unload on your timeline, even if that's 2 AM on a Sunday.\n\n",
								newlayout: false,
							},
							{
								image: timeIcon,
								content:
									'#### For Shift Workers & Night Owls\n\n' +
									"If you work nights, weekends, or irregular hours, a 24-hour storage facility lets you handle your storage needs when it's convenient for you, not when it's convenient for the facility.\n\n",
								newlayout: false,
							},
							{
								image: sparkIcon,
								content:
									'#### For Emergency Access\n\n' +
									"Forgot something important for tomorrow's presentation? Need camping gear for an impromptu trip? 24-hour access storage means you're never locked out when life throws a curveball.\n\n",
								newlayout: false,
							},
							{
								image: twentyFourHourIcon,
								content:
									'#### For Flexibility & Peace of Mind\n\n' +
									"Even if you don't need after-hours access often, knowing you have it eliminates stress and gives you complete control over your stored items.",
								newlayout: false,
							},
						],
					},
				},
			],
		},
		{
			title: '24-Hour Storage Unit Size Guide',
			background: 'yellow',
			modules: [
				{
					type: 'content',
					props: {
						title: '24-Hour Storage Unit Size Guide',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [],
					},
				},
				{
					type: 'sizeChart',
					props: {
						headers: [
							{
								label: 'Unit Size',
								key: 'Unit Size',
							},
							{
								label: 'Average Monthly Price',
								key: 'Average Monthly Price',
							},
							{
								label: 'What Fits',
								key: 'What Fits',
							},
						],
						rows: [
							{
								'Unit Size': {
									type: 'icon',
									icon: fiveByTenIcon,
									description:
										'#### [5×10](https://www.sparefoot.com/blog/50-things-you-can-store-in-5x10-storage-unit)',
								},
								'Average Monthly Price': '$35.27',
								'What Fits':
									'Small furniture, seasonal decorations, personal items, gardening equipment, camping gear, off-season clothing',
							},
							{
								'Unit Size': {
									type: 'icon',
									icon: tenByTenIcon,
									description:
										'#### [10×10](https://www.sparefoot.com/blog/10x10-storage-unit-size-guide)',
								},
								'Average Monthly Price': '$51.47',
								'What Fits':
									'One-bedroom apartment or dorm room, including a queen-sized mattress set, love seat, dresser, TV, bike, and several boxes',
							},
							{
								'Unit Size': {
									type: 'icon',
									icon: tenByFifteenIcon,
									description:
										'#### [10×15](https://www.sparefoot.com/blog/what-can-you-fit-inside-of-a-10x15-storage-unit)',
								},
								'Average Monthly Price': '$82.81',
								'What Fits':
									'Two bedrooms (mattresses, dressers, nightstands) and a family room (sofa, chairs, coffee table, bookshelves)',
							},
							{
								'Unit Size': {
									type: 'icon',
									icon: tenByTwentyIcon,
									description:
										'#### [10×20](https://www.sparefoot.com/blog/10x20-storage-unit-size-guide)',
								},
								'Average Monthly Price': '$109.48',
								'What Fits':
									'Three bedrooms plus large items like big-screen TVs, couches, pianos, tables, or appliances',
							},
							{
								'Unit Size': {
									type: 'icon',
									icon: tenByThirtyIcon,
									description:
										'#### [10×30](https://www.sparefoot.com/blog/10x30-storage-unit-size-guide)',
								},
								'Average Monthly Price': '$132.43',
								'What Fits':
									'Three- or four-bedroom house including couches, mattress sets, dining room set, workout equipment, refrigerator, washer, and dryer',
							},
						],
					},
				},
				{
					type: 'content',
					props: {
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'*This pricing is based on average rates across SpareFoot.com facilities*',
						],
					},
				},
			],
		},
		{
			title: 'What Makes 24/7 Storage Different?',
			modules: [
				{
					type: 'content',
					props: {
						title: 'What Makes 24/7 Storage Different?',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [],
					},
				},
				{
					type: 'sizeChart',
					props: {
						headers: [
							{
								label: '24/7 Access Storage Feature',
								key: '24/7 Access Storage Feature',
							},
							{
								label: 'Benefit of Around the Clock Access',
								key: 'Benefit of Around the Clock Access',
							},
							{
								label: 'Best For',
								key: 'Best For',
							},
						],
						rows: [
							{
								'24/7 Access Storage Feature': {
									type: 'markdown',
									markdown:
										'**Keypad or Gate Access Systems**',
								},
								'Benefit of Around the Clock Access':
									'Secure electronic access systems allow you to enter with a personal code anytime, day or night.',
								'Best For': {
									type: 'markdown',
									markdown:
										'- Night shift workers\n- Business owners needing off-hours access\n- Frequent travelers\n- Students with irregular schedules',
								},
							},
							{
								'24/7 Access Storage Feature': {
									type: 'markdown',
									markdown: '**Enhanced Security**',
								},
								'Benefit of Around the Clock Access':
									'Many 24/7 storage facilities use surveillance cameras, monitor entry points, and remain well-lit 24 hours a day.',
								'Best For': {
									type: 'markdown',
									markdown:
										'- Military families\n- Security-focused renters\n- High-value stored belongings\n- Peace of mind in densely populated or extremely busy areas',
								},
							},
							{
								'24/7 Access Storage Feature': {
									type: 'markdown',
									markdown: '**Convenience & Flexibility**',
								},
								'Benefit of Around the Clock Access':
									'In addition to accessing your belongings on your own time, many of these facilities offer drive-up units, wide driveways, and powered units.',
								'Best For': {
									type: 'markdown',
									markdown:
										'- Business owners\n- Military families\n- Night owls\n- Storage users with large items requiring transport at odd-hours\n- Second and third shift workers',
								},
							},
						],
					},
				},
			],
		},
		{
			title: 'Reviews Section',
			background: 'dark',
			modules: [
				{
					type: 'reviews',
					slug: '24-hour-reviews',
					title: '24 Hour Storage Search: Join Other Happy SpareFoot Customers',
					props: {
						reviews,
						title: '24 Hour Storage Search: Join Other Happy SpareFoot Customers',
					},
				},
			],
		},
		{
			title: 'Faqs Section',
			modules: [
				{
					type: 'faqs',
					props: {
						header: '24-Hour Access Storage FAQs',
						faqs,
					},
				},
			],
		},
		{
			title: 'featured content',
			background: 'gray',
			modules: [
				{
					type: 'featuredContent',
					props: {
						slug: '24-hour-featured-content',
						contentCards: [
							{
								title: 'Tips for Choosing a Self-Storage Facility',
								date: 'August 4, 2025',
								image: Featured1,
								content:
									'Practical tips for choosing the right self-storage facility for your needs.',
								link: 'https://www.sparefoot.com/blog/tips-for-choosing-a-self-storage-facility',
							},
							{
								title: 'How Much Does It Cost To Rent a Storage Unit?',
								date: 'September 5, 2025',
								image: Featured2,
								content:
									'Industry trends and pricing insights to help you budget for storage.',
								link: 'https://www.sparefoot.com/blog/how-much-does-a-storage-unit-cost',
							},
							{
								title: 'What You Need To Know About Business Storage',
								date: 'October 27, 2025',
								image: Featured3,
								content:
									'Key considerations for storing business inventory and equipment.',
								link: 'https://www.sparefoot.com/blog/need-know-business-storage',
							},
						],
					},
				},
			],
		},
		{
			title: 'Link to other PSPs',
			background: 'yellow',
			modules: [
				{
					type: 'links',
					props: {
						title: 'More Ways to Store',
						cards: [
							'ClimateControl',
							'DriveUp',
							'Electricity',
							'Car',
							'Business',
							'RV',
							'College',
							'Vehicle',
						],
					},
				},
			],
		},
		{
			title: 'nearby units',
			modules: [
				{
					type: 'storageNearYou',
				},
			],
		},
	],
};
